export const language = {
  en: {
    'Supplier Verification': 'Supplier Verification',
    'View': 'View',
    'Verify': 'Verify',
    'Please Entry': 'Please Entry',
    'Please select': 'Please select',
    'Select Start Time': 'Select Start Time',
    'Select End Time': 'Select End Time',
    'In total': 'In total',
    'data': 'data',

    'Serial Number': 'Serial Number',
    'Approval Form Number': 'Approval Form Number',
    'Supplier Name': 'Supplier Name',
    'Approval Status': 'Approval Status',
    'Apply Time': 'Apply Time',
    'Operate': 'Operate',

    'Category': 'Category',

    'resetting': 'resetting',
    'query': 'query',
    'Back': 'Back',
    'Submit': 'Submit',

    'Approval Form Information': 'Approval Form Information',
    'Approval Form Status': 'Approval Form Status',
    'Applicant': 'Applicant',

    'Basic information of the company': 'Basic information of the company',
    'Company Name': 'Company Name',
    'Company Name English': 'Company Name English',
    'Unified Social Credit Code': 'Unified Social Credit Code',
    'Company Country': 'Company Country',
    'Company Address': 'Company Address',
    'Bank Name': 'Bank Name',
    'Bank Account': 'Bank Account',
    'Landline Number': 'Landline Number',
    'Tel Number': 'Tel Number',
    'Email': 'Email',
    'Whether Production Base': 'Whether Production Base',
    'Operating years': 'Operating years',
    'Annual turnover': 'Annual turnover',
    'Rgistered capital': 'Rgistered capital',

    'Company Address Information': 'Company Address Information',
    'Contact Name': 'Contact Name',
    'Telephone': 'Telephone',
    'Address': 'Address',
    'Zip code': 'Zip code',
    'Remarks': 'Remarks',

    'Company Qualification Information': 'Company Qualification Information',
    'Business License': 'Business License',
    'Legal Person Certificate': 'Legal Person Certificate',
    'Account Opening Permit': 'Account Opening Permit',
    'Road Transport License': 'Road Transport License',
    'Taxpayer Qualification Certificate': 'Taxpayer Qualification Certificate',
    'Member payment voucher': 'Member payment voucher',
    'Proof of Business Performance': 'Proof of Business Performance',
    'Qualification materials': 'Qualification materials',

    'Approval Record': 'Approval Record',
    'Approval opinions': 'Approval opinions',
    'Approval time': 'Approval time',
    'system': 'system',
    'Approved': 'Approved',
    'Approval Rejection': 'Approval Rejection',
    'Submit application': 'Submit application',
    'Submission time': 'Submission time',

    'Approval results': 'Approval results',

    'Audit': 'Audit',
    'Audit Reject': 'Audit Reject',
    'OA/OB Pending Approval': 'OA/OB Pending Approval',
    'Yes': 'Yes',
    'No': 'No',
    'All': 'All',
    'time': 'time',
    'submit': 'submit',
    'approve': 'approve',
    'Name': 'Name',
    'ID': 'ID',
    'Name Type': 'Name Type'
  },
  zh: {
    'Supplier Verification': '供应商审批',
    'View': '查看',
    'Verify': '审核',
    'Please Entry': '请输入',
    'Please select': '请选择',
    'Select Start Time': '选择开始时间',
    'Select End Time': '选择结束时间',
    'In total': '总共',
    'data': '数据',

    'Serial Number': '序号',
    'Approval Form Number': '审批单号',
    'Supplier Name': '供应商名称',
    'Approval Status': '审批状态',
    'Apply Time': '申请时间',
    'Operate': '操作',

    'Category': '经营品类',

    'resetting': '重置',
    'query': '查询',
    'Back': '返回',
    'Submit': '确定',

    'Approval Form Information': '审批单信息',
    'Approval Form Status': '审批单状态',
    'Applicant': '申请人',

    'Basic information of the company': '公司基本信息',
    'Company Name': '公司名称',
    'Company Name English': '公司名称(英文)',
    'Unified Social Credit Code': '统一社会信用代码',
    'Company Country': '公司所在国家',
    'Company Address': '公司地址',
    'Bank Name': '银行名称',
    'Bank Account': '银行账号',
    'Landline Number': '座机号',
    'Tel Number': '手机号',
    'Email': '邮箱',
    'Whether Production Base': '是否基地',
    'Operating years': '经营年限',
    'Annual turnover': '年营业额',
    'Rgistered capital': '注册资本金',

    'Company Address Information': '公司地址信息',
    'Contact Name': '联系人姓名',
    'Telephone': '联系电话',
    'Address': '地址',
    'Zip code': '邮编',
    'Remarks': '备注',

    'Company Qualification Information': '公司资质信息',
    'Business License': '营业执照',
    'Legal Person Certificate': '法人证件照',
    'Account Opening Permit': '开户许可证',
    'Road Transport License': '道路运输许可证',
    'Taxpayer Qualification Certificate': '纳税人资格证明',
    'Member payment voucher': '会员付费凭证',
    'Proof of Business Performance': '经营业绩证明',
    'Qualification materials': '资质材料',

    'Approval Record': '审批记录',
    'Approval opinions': '审批意见',
    'Approval time': '审批时间',
    'system': '系统',
    'Approved': '审批通过',
    'Approval Rejection': '审批拒绝',
    'Submit application': '提交申请',
    'Submission time': '提交时间',

    'Approval results': '审批结果',

    'Audit': '待审核',
    'Audit Reject': '审核拒绝',
    'OA/OB Pending Approval': '待OA/OB审核',
    'Yes': '是',
    'No': '否',
    'All': '全部',
    'time': '时间',
    'submit': '提交',
    'approve': '审批',
    'Name': '姓名',
    'ID': '身份证号',
    'Name Type': '公司类型'
  }
};
